<template functional>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 548.47 548.47" style="fill:none;stroke:#000;stroke-width:24.81px"><rect class="cls-1" x="10.23" y="10.23" width="528" height="528" rx="62.81"/><rect class="cls-2" x="84.14" y="127.31" width="380.19" height="118.89"/><circle cx="70.27" cy="62.46" r="13.54"/><circle cx="117.65" cy="62.46" r="13.54"/><circle cx="165.03" cy="62.46" r="13.54"/></svg>
</template>

<script>
export default {}
</script>
